import React from 'react';

export default class ReviewerIsRecipientComponent extends React.Component {
  render() {
    const {context} = this.props;
    return (
      <div>
        {context.negated && (
          <span>
            the call is{' '}
            <span onClick={this.props.onClick} className="condition-action">
              placed by anybody except the reviewer
            </span>
          </span>
        )}
        {!context.negated && (
          <span>
            the call is{' '}
            <span onClick={this.props.onClick} className="condition-action ">
              placed by the reviewer
            </span>
          </span>
        )}
      </div>
    );
  }
}
